import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie9';
import 'custom-event-polyfill';

import { Constants, ModelManager } from '@adobe/aem-spa-page-model-manager';
import { createBrowserHistory } from 'history';
import React from 'react';
import { render } from 'react-dom';
import { AuthServiceProvider, AuthGate } from '@trp-ta-nitro/auth-react';
import { ConnectedRouter } from 'connected-react-router';
import store, { history } from './redux/configure-store';
import App from './App';
import LocalDevModelClient from './LocalDevModelClient';
import './components/import-components';
import './index.css';
import {Provider} from "react-redux";
import { useSelector } from "react-redux";
import { selectApiKey } from "./redux/app-config/selectors";
import AppConfigLoader from './AppConfigLoader';
import checkAndResetPageModel, {localPageModel} from 'page-model.local';
import {getDomain} from "./utils/api";

// const modelManagerOptions = {};
// if(process.env.REACT_APP_PROXY_ENABLED) {
//     modelManagerOptions.modelClient = new LocalDevModelClient(process.env.REACT_APP_API_HOST);
// }                                    

//  Get root element in dom where application will be rendered
const rootElement = document.getElementById('spa-root');

const isLocalhost = window && window.location.hostname.toLowerCase().indexOf('localhost') !== -1;
let isAuthorEnvironment = false;
const isAuthorEnvironmentLocal = isLocalhost && window && window.location.port !== `${process.env.REACT_APP_PORT}`;
const configs = isLocalhost
  ? [
      `http://localhost.troweprice.com:${process.env.REACT_APP_PORT}/baseConfig.json`,
      `http://localhost.troweprice.com:${process.env.REACT_APP_PORT}/envConfig.json`,
    ]
  : ['baseConfig.json', 'envConfig.json'];

const AuthenticatedApp = (props: any) => {
    const { pageModel } = props;
    const apiKey = useSelector(selectApiKey);

    if (!apiKey) {
        throw new Error(
            "apiKey is unavailable. AuthenticatedApp likely loaded before reduxStore.app-config was initialized."
        );
    }

    // the auth options here lean heavily on the defaults, any other configuration could be
    // pulled in:
    //   - static configuration here
    //   - via the app state (where the apiKey is currently coming from)
    //   - a separate fetch here to specific config
    const authOptions = {
        apiKey,
        types: {
            // enable external and internal both, no extra options are required so none are passed
            external: {},
            internal: {}
        }
    };
    // const history = createBrowserHistory();

    return (
        <AuthServiceProvider options={authOptions}>
            <AuthGate>
                    <App
                        history={history}
                        cqChildren={pageModel[Constants.CHILDREN_PROP]}
                        cqItems={pageModel[Constants.ITEMS_PROP]}
                        cqItemsOrder={pageModel[Constants.ITEMS_ORDER_PROP]}
                        cqPath={pageModel[Constants.PATH_PROP]}
                        locationPathname={window.location.pathname}
                    />
            </AuthGate>
        </AuthServiceProvider>
    );
};

const ConfiguredAndAuthenticatedApp = (props: any) => {
    const { pageModel } = props;
    return (
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <AppConfigLoader configs={configs}>
                    <AuthenticatedApp pageModel={pageModel} />
                </AppConfigLoader>
            </ConnectedRouter>
        </Provider>
    );
};

const RootComponent = (props: any) => {
    const history = createBrowserHistory();
    const { pageModel } = props;
    return (
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <App
                    history={history}
                    cqChildren={pageModel[Constants.CHILDREN_PROP]}
                    cqItems={pageModel[Constants.ITEMS_PROP]}
                    cqItemsOrder={pageModel[Constants.ITEMS_ORDER_PROP]}
                    cqPath={pageModel[Constants.PATH_PROP]}
                    locationPathname={window.location.pathname}
                />
            </ConnectedRouter>
        </Provider>
    );
  };


document.addEventListener('DOMContentLoaded', () => {

    fetch('/content/workplace/en/participant/profile.model.json').then(response => {
        if (response.headers.get('X-Vhost') === 'author') {
          isAuthorEnvironment = true;
        }
        return;
      });

    ModelManager.initialize({ path: '/content/workplace/en/participant/profile' }).then((pageModel: any) => {
        //comment-out below line while aem author deployment
        pageModel = checkAndResetPageModel(pageModel);

        if (isLocalhost || isAuthorEnvironmentLocal || isAuthorEnvironment) {
            render(<RootComponent pageModel={pageModel} />, rootElement);
        } else {
            if(window.location.href.indexOf('preference.html') > -1) {
                window.location = `${awsWorkplaceDomain}/workplace/en/participant/profile/index.html`;
            } else {
                render(<ConfiguredAndAuthenticatedApp pageModel={pageModel}/>, rootElement);
            }
        }
    });
});
